import { SmartRateFaqQuestionResponse } from '@classpass/protobuf-definitions/lib/web/models/partners/smart_rate_faq';
import { useQuery } from '@tanstack/react-query';

import URLS from 'constants/urls';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';

export const smartRateFaqKeys = {
  all: ['smartRateFaqs'],
};

async function fetchSmartRateFaqs() {
  try {
    const response = await httpClient.get(URLS.smartRate.faqs);
    return SmartRateFaqQuestionResponse.fromJSON(response?.data || {}).faqs || [];
  } catch (error) {
    reportError(error);
    throw error;
  }
}

export function useSmartRateFaqsQuery(options = {}) {
  return useQuery({
    queryKey: smartRateFaqKeys.all,
    queryFn: fetchSmartRateFaqs,
    ...options,
  });
}
